import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";
import Select from "react-select";
//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_WEEKLY_STAR_GIFT_DIALOG } from "../../store/weeklyStar/types";

//action
import { updateWeeklyStarGifts } from "../../store/weeklyStar/action";

import { getCategory } from "../../store/giftCategory/action";
import { getGift } from "../../store/gift/action";

const WeeklyStarGiftDialog = (props) => {
  const dispatch = useDispatch();

  const { giftDialog: open, giftDialogData: dialogData } = useSelector(
    (state) => state.weeklyStar,
  );
  const categories = useSelector((state) => state.giftCategory.giftCategory);
  const gift = useSelector((state) => state.gift.gift);

  const [selectedGift, setSelectedGift] = useState(null);
  const [selectedGiftCategory, setSelectedGiftCategory] = useState("");

  const [giftOptions, setGiftOptions] = useState([]);
  const [giftCategoryOptions, setGiftCategoryOptions] = useState([]);
  const [index, setIndex] = useState(null);
  const [currentGift, setCurrentGift] = useState(null);
  const [errors, setErrors] = useState({
    gift: "",
  });

  const closePopup = () => {
    dispatch({ type: CLOSE_WEEKLY_STAR_GIFT_DIALOG });
  };

  useEffect(() => {
    props.getCategory();
  }, []);

  useEffect(() => {
    if (dialogData) {
      // `giftData` is null and `index` is null when a new eligible gift is being set.
      setCurrentGift(dialogData.giftData);
      setIndex(dialogData.index);
      setSelectedGift(null);
      setErrors({ gift: "" });
    }
  }, [dialogData]);

  useEffect(() => {
    if (gift && gift.length > 0) {
      const options = gift.map((item, index) => ({
        value: item._id,
        label: item.name,
        image: item.type === 2 ? item.imagePreview : item.image,
        index: index,
      }));
      setGiftOptions(options);
    }
  }, [gift]);

  useEffect(() => {
    if (categories && categories.length > 0) {
      const options = categories.map((item, index) => ({
        value: item._id,
        label: item.name,
        image: item.image,
        index: index,
      }));
      setGiftCategoryOptions(options);
      if (!selectedGiftCategory) {
        setSelectedGiftCategory(categories[0]?._id);
        props.getGift(categories[0]?._id);
      }
    }
  }, [categories]);

  useEffect(() => {
    if (selectedGiftCategory) {
      props.getGift(selectedGiftCategory);
    }
  }, [selectedGiftCategory]);

  const handleSubmit = () => {
    if (!selectedGift) {
      return setErrors({ ...errors, gift: "Gift is required." });
    }

    props.updateWeeklyStarGifts(index, selectedGift.value);
    closePopup();
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4">
            {currentGift
              ? `Update Weekly Vibe Star Gift (${currentGift?.name})`
              : "Set Weekly Vibe Star Eligible Gift"}
          </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="mb-3 col-md-12">
                  <label htmlFor="giftCategory" className="form-label">
                    Gift Category
                  </label>
                  <select
                    className="form-select form-control"
                    aria-label="Default select example"
                    value={selectedGiftCategory || ""}
                    onChange={(e) => {
                      setSelectedGiftCategory(e.target.value);
                    }}
                  >
                    {giftCategoryOptions.map((category) => {
                      return (
                        <option key={category.value} value={category.value}>
                          {category.label}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div>
                  <label className="form-label">Gift</label>
                  <Select
                    options={giftOptions}
                    value={selectedGift}
                    onChange={(selected) => setSelectedGift(selected)}
                    formatOptionLabel={(option) => (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <img
                          src={option.image}
                          style={{ width: 40, height: 40, marginRight: 10 }}
                          alt={option.label}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>{option.label}</span>
                          <span>ID: {option.value}</span>
                        </div>
                      </div>
                    )}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary: "#e8538f",
                        neutral0: "#1f1f2b",
                        neutral80: "#fff",
                        primary25: "#181821 ",
                        primary50: "#cf779a",
                      },
                    })}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: "#2d2d3f",
                        borderRadius: 3,
                      }),
                    }}
                  />

                  {!selectedGift && (
                    <div className="ml-2 mt-1">
                      <div className="pl-1 text__left">
                        <span className="text-red">{errors.gift}</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-end gap-3 mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closePopup}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, {
  getCategory,
  getGift,
  updateWeeklyStarGifts,
})(WeeklyStarGiftDialog);
